import _ from "lodash";
import { getCreateArtefactsUrl, getCreateCodelistUrl } from "../../../constants/urls";
import { REQUEST_METHOD_POST } from "../../../middlewares/api/actions";
import { getFilterObjFromStr, getServerQueryObj } from "../../../utils/filter";
import { DSD_ATTRIBUTE_ATTACHMENT_LEVEL_DATASET, DSD_ATTRIBUTE_ATTACHMENT_LEVEL_OBSERVATION, DSD_ATTRIBUTE_ATTACHMENT_LEVEL_SERIES, DSD_DIMENSION_TYPE_FREQUENCY, DSD_DIMENSION_TYPE_MEASURE, DSD_DIMENSION_TYPE_NORMAL, DSD_DIMENSION_TYPE_TIME, getSdmxJsonFromSdmxJsonStructures, getSdmxJsonStructureFromArtefact, getUrnFromArtefact, getUrnFromArtefactTriplet,  SDMX_JSON_CONCEPT_SCHEME_LIST_KEY, SDMX_JSON_INFO_MODEL_CODELIST_URN_NAMESPACE, SDMX_JSON_INFO_MODEL_CONCEPT_URN_NAMESPACE } from "../../../utils/sdmxJson";
import { EL_ATTRIBUTE_REFERS_DATASET, EL_ATTRIBUTE_REFERS_DIMENSION, EL_ATTRIBUTE_REFERS_OBSERVATION, EL_COL_TYPE_ATTRIBUTE, EL_COL_TYPE_DIMENSION, EL_COL_TYPE_IGNORE, EL_COL_TYPE_MEASURE, EL_COL_TYPE_TRANSLATION, EL_DIMENSION_ROLE_FREQUENCY, EL_DIMENSION_ROLE_MEASURE,  EL_DIMENSION_ROLE_TERRITORY,  EL_DIMENSION_ROLE_TIME, EL_LOAD_CUBE_COMPONENT_TYPE_ATTRIBUTE, EL_LOAD_CUBE_COMPONENT_TYPE_DIMENSION, EL_LOAD_CUBE_COMPONENT_TYPE_MEASURE, EL_LOAD_CUBE_COMPONENT_TYPE_TIME_DIMENSION, EL_SEMANTIC_CONCEPT_EXISTING, EL_SEMANTIC_CONCEPT_NEW } from "../constants";

const ValidId = (id) => {
  return id.replace(/([^0-9A-Z_-]+)/gi, '_').toUpperCase();
}


export const getCreateCodelistsRequests = (structureColumns, filterStr, dfId, tableName, inStagingDb) => {
    
  const requestsMethod = [];
  const requestsUrl = [];
  const requestsBody = [];
  const requestData = [];
  const filter = getServerQueryObj(null,getFilterObjFromStr(filterStr) ).Filter;
  const translations = structureColumns.filter(column => column.type === EL_COL_TYPE_TRANSLATION)
  .map(column => {
    return {
      id: column.id, 
      lang: column.translationDefinition.langCode, 
      translatedColumn:column.translationDefinition.transColId 
    }
  });
  if (translations.length > 0) {
    var translatedColumns = _.mapValues(_.groupBy(translations, 'translatedColumn'), 
      tList => tList.map(t => _.omit(t, 'translatedColumn')));
    var dict = {};
    Object.keys(translatedColumns).forEach(column => {
      const idKvp = {"Key":"Id", "Value":column};
      const lst = [idKvp];
      translatedColumns[column].forEach( t => {
        const kvp = {"Key":t.lang, "Value":t.id};
        lst.push(kvp);
      });
      dict[ValidId(column)] = lst;
      requestData.push(ValidId(column));
    })
    var req = {};
    req["filter"] = filter;
    req["cols"] = dict;
    const requestBody = req;
    requestsMethod.push(REQUEST_METHOD_POST);
    requestsUrl.push(getCreateCodelistUrl(dfId, tableName, inStagingDb));
    requestsBody.push(requestBody);

    const codelistRequests = {
      methods: requestsMethod, 
      urls: requestsUrl, 
      body: requestsBody,
      data: requestData
    };

    return codelistRequests
  }
  return null;

}

export const getCreateConceptRequest = (structureColumns, dstDataflow, appLang) => {
 
  let newConcepts = [];
  let columnsConcepts = {};

  const id = dstDataflow.id;
  const agencyID = dstDataflow.agencyID;
  const version = dstDataflow.version;

  structureColumns.filter(column => 
    column.type !== EL_COL_TYPE_IGNORE &&  column.type !== EL_COL_TYPE_TRANSLATION &&
    column.semanticDefinition.conceptType === EL_SEMANTIC_CONCEPT_NEW)
    .forEach(column => {
      const concept = {
        id: `${ValidId(column.id)}`,
        names: column.semanticDefinition.newConcept
      }
      newConcepts.push(concept);
      columnsConcepts[column.id] = concept;
    })

    if (newConcepts.length > 0) {

      const name = {};
      name[appLang] = `Concept scheme for dataflow ${id}+${agencyID}+${version}`;

      let csId = `CS_${id}_${agencyID}_${version.replace('.', '_')}`;
      const suffix = String(_.random(99999)).padStart(5, '0');
      csId = csId.substring(0,44) + '_' + suffix;
        
      const conceptSchema = {
        id: csId, 
        agencyID: "AST",
        version: "1.0",
        isFinal: true,
        name: name,
        concepts:newConcepts 
      }

       return({
        methods: [REQUEST_METHOD_POST],
        urls:[getCreateArtefactsUrl()],
        body:[getSdmxJsonFromSdmxJsonStructures(
          [getSdmxJsonStructureFromArtefact(conceptSchema)],
          SDMX_JSON_CONCEPT_SCHEME_LIST_KEY
        )],
        data: {
          conceptSchema: conceptSchema,
          columnsConcepts: columnsConcepts
        }
       });
      
    }
    return null;
}

const getConceptUrn = (column, conceptSchemaDefinition) => {
  if (column.semanticDefinition.conceptType === EL_SEMANTIC_CONCEPT_EXISTING) {
    return getUrnFromArtefact(column.semanticDefinition.concept);
  } else {
    const columnConcept = conceptSchemaDefinition.columnsConcepts[column.id];
    const conceptSchema = conceptSchemaDefinition.conceptSchema
    const conceptSchemaUrn = getUrnFromArtefactTriplet(conceptSchema, SDMX_JSON_INFO_MODEL_CONCEPT_URN_NAMESPACE);
    return `${conceptSchemaUrn}.${columnConcept.id}`;
  }  
}

const getAttributeAttachmentData = (attributeDefinition) => {
  let attachmentLevel;
  let attachedDimensions = null;
  let attributeRelationship = {};
  switch (attributeDefinition.refers) {
    case EL_ATTRIBUTE_REFERS_OBSERVATION:
    default:
      attachmentLevel = DSD_ATTRIBUTE_ATTACHMENT_LEVEL_OBSERVATION;
      break;
    case EL_ATTRIBUTE_REFERS_DATASET:
      attachmentLevel = DSD_ATTRIBUTE_ATTACHMENT_LEVEL_DATASET;
      break;
    case EL_ATTRIBUTE_REFERS_DIMENSION:
        attachmentLevel = DSD_ATTRIBUTE_ATTACHMENT_LEVEL_SERIES;
        attachedDimensions = attributeDefinition.dimensions;
        attributeRelationship = {
          "dimensions": attributeDefinition.dimensions
        };
        break;        
  }

  return {
    level: attachmentLevel,
    dimensions: attachedDimensions,
    attributeRelationship: attributeRelationship
  }
}

const getDimensionData = (column, timeDimensionOrder, codelists, astTerritoryDimId) => {
  let type;
  let order = 0;
  let representation = null;
  let id = ValidId(column.id);
  switch (column.dimensionDefinition.role) {
    case EL_DIMENSION_ROLE_FREQUENCY:
      type = DSD_DIMENSION_TYPE_FREQUENCY;
      order = 1; 
      break;
    case EL_DIMENSION_ROLE_MEASURE:
      type = DSD_DIMENSION_TYPE_MEASURE;
      break;
    case EL_DIMENSION_ROLE_TIME:
      type = DSD_DIMENSION_TYPE_TIME;
      order = timeDimensionOrder;
      break;
    case EL_DIMENSION_ROLE_TERRITORY:
      type = DSD_DIMENSION_TYPE_NORMAL;
      id = astTerritoryDimId;
      break;
    default:
      type = DSD_DIMENSION_TYPE_NORMAL;
  }

  if (column.dimensionDefinition.role !== EL_DIMENSION_ROLE_TIME) {
    if (column.dimensionDefinition.association) {
      try {
        representation = getUrnFromArtefact(column.dimensionDefinition.association);
      } catch (e) {
        representation = getUrnFromArtefactTriplet(column.dimensionDefinition.association, 
          SDMX_JSON_INFO_MODEL_CODELIST_URN_NAMESPACE);
      }
    } else {
      const codelist = codelists[ValidId(column.id)];
      representation = getUrnFromArtefactTriplet({
        id: codelist,
        agencyID:"AST",
        version:"1.0"
      }, SDMX_JSON_INFO_MODEL_CODELIST_URN_NAMESPACE);
    }
  }

  return {
    id: id,
    type: type,
    order: order,
    representation:  representation
  }

}

export const getDataflowDSD = (structureColumns, dstDataflow, appLang, codelists, conceptSchemaDefinition, astTerritoryDimId) => {

  const name = {};
  name[appLang] = `DSD for dataflow ${dstDataflow.id}+${dstDataflow.agencyID}+${dstDataflow.version}`;
  const dimensions = [];
  const attributes = [];    
  let attrOrder = 1; 

  const columns = structureColumns.filter(column => column.type !== EL_COL_TYPE_IGNORE); 
  const timeDimensionOrder = columns.filter(column => column.type === EL_COL_TYPE_DIMENSION).length;
  let dimensionOrder = 1;
  if (columns.some(column => column.dimensionDefinition.role === EL_DIMENSION_ROLE_FREQUENCY)) {
    dimensionOrder = 2;
  }

  // const dsdId = `DSD_${dstDataflow.id}_${dstDataflow.agencyID}_${dstDataflow.version.replace('.', '')}`;

  let dsdId = `DSD_${dstDataflow.id}_${dstDataflow.agencyID}_${dstDataflow.version.replace('.', '_')}`;
  const suffix = String(_.random(99999)).padStart(5, '0');
  dsdId = dsdId.substring(0,44) + '_' + suffix;

  const dsd = {
    id: dsdId, 
    agencyID: "AST",
    version: "1.0",
    isFinal: true,
    name: name
  }


  columns.forEach(column => {
    if (column.type === EL_COL_TYPE_MEASURE) {    
      dsd.primaryMeasure = {
        id: ValidId(column.id),
        concept: getConceptUrn(column,conceptSchemaDefinition),
        representation: null,
        annotations: null       
      };      
    } else if (column.type === EL_COL_TYPE_ATTRIBUTE) {
      
      const attachmentData = getAttributeAttachmentData(column.attributeDefinition);

      const attribute = {
        id: ValidId(column.id),
        order: attrOrder++,
        concept: getConceptUrn(column,conceptSchemaDefinition),
        representation: column.attributeDefinition.association 
          ? getUrnFromArtefact(column.attributeDefinition.association)
          : null,
        assignmentStatus: "Conditional",
        attachmentLevel: attachmentData.level,
        annotations: null,
        attachedDimensions: attachmentData.dimensions,
        attachmentGroup: null,
        attributeRelationship: attachmentData.attributeRelationship
      };
      attributes.push(attribute);
    } else if (column.type === EL_COL_TYPE_DIMENSION) {
    
      const dimensionData = getDimensionData(column, timeDimensionOrder, codelists, astTerritoryDimId);
      
      const dimension = {
        type: dimensionData.type,
        id: dimensionData.id,
        order: dimensionData.order === 0 ? dimensionOrder++ : dimensionData.order,
        concept: getConceptUrn(column,conceptSchemaDefinition),
        representation: dimensionData.representation      
      };
      dimensions.push(dimension);
    }
  });

  dsd.dimensions = dimensions;
  dsd.attributes = attributes;
  dsd.annotations = [];

  return dsd;
}

export const getCreateFileComponentMapping = (structureColumns, astTerritoryDimId) => {
  const componentMapping = [];
  const columns = structureColumns.filter(column => 
    column.type === EL_COL_TYPE_MEASURE || column.type === EL_COL_TYPE_ATTRIBUTE || column.type === EL_COL_TYPE_DIMENSION);

  columns.forEach(column => { 
    let cubeComponentCode = ValidId(column.id);
    let cubeComponentType = EL_LOAD_CUBE_COMPONENT_TYPE_DIMENSION;
    switch (column.type) {
      case EL_COL_TYPE_MEASURE:
        cubeComponentType = EL_LOAD_CUBE_COMPONENT_TYPE_MEASURE;
        break;
      case EL_COL_TYPE_ATTRIBUTE:
        cubeComponentType = EL_LOAD_CUBE_COMPONENT_TYPE_ATTRIBUTE;
        break;
      case EL_COL_TYPE_DIMENSION:
      default:
        if (column.dimensionDefinition.role === EL_DIMENSION_ROLE_TIME) {
          cubeComponentType = EL_LOAD_CUBE_COMPONENT_TYPE_TIME_DIMENSION
        }
        else if(column.dimensionDefinition.role === EL_DIMENSION_ROLE_TERRITORY) {
          cubeComponentCode = ValidId(astTerritoryDimId);
        }
        break;
    }

    const mapping = {
      idComp: 0,
      idMapping: 0,
      columnName: column.id,
      cubeComponentCode: cubeComponentCode,
      cubeComponentType: cubeComponentType,
      mappingType: 0
    };

    componentMapping.push(mapping);

  });

  return componentMapping;
}

export const getUpdateFileComponentMapping = (components) => {
  const componentMapping = [];

  components.forEach(component => {
    const mapping = {
      idComp: 0,
      idMapping: 0,
      columnName: component.columnName,
      cubeComponentCode: component.cubeComponentCode,
      cubeComponentType: component.cubeComponentType,
      mappingType: 0
    };

    componentMapping.push(mapping);

  });

  return componentMapping;
}


// WEBPACK FOOTER //
// ./src/components/easy-loading/load-step/utils.js